<script setup lang="ts">
// icons
import { faTimesCircle } from '@fortawesome/pro-regular-svg-icons';

export interface CiMapCampsiteModalProps {
  campsite: any;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  getAvailabilities: Function;
}
const props = withDefaults(defineProps<CiMapCampsiteModalProps>(), {});

const emit = defineEmits<{
  close: [];
}>();

/********************
 * REFS & VARS       *
 ********************/
const flexAvailabilities = ref([]);

/********************
 * COMPOSITIONS      *
 ********************/
const { $gettext } = useGettext();

/********************
 * FUNCTIONS         *
 ********************/
async function onShowFlex() {
  const flexAvs = await props.getAvailabilities(props.campsite.slug);
  flexAvailabilities.value = flexAvs;
}
</script>

<template>
  <div class="flex">
    <button
      type="button"
      class="button ml-auto mr-2 rounded-lg rounded-b-none bg-white py-0 pt-1"
      @click="emit('close')"
    >
      <span>{{ $gettext('Close') }}</span>
      <CiAwesomeIcon
        :icon="faTimesCircle"
        ratio="0.5"
      />
    </button>
  </div>
  <div class="rounded-lg bg-white shadow-2xl">
    <CiCampsiteTileAs
      class="border-0 p-2"
      :campsite="props.campsite"
      :snowplow-context="{
        bannerId: 'map-modal',
        position: null,
      }"
      :flex-availabilities="flexAvailabilities"
      :show-no-availability-info="true"
      :show-location-link="false"
      :show-border="false"
      :allow-sponsored="false"
      @show-flex="onShowFlex"
    />
  </div>
</template>

<style></style>
